import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchOnboardings } from "services/onboarding.service";
import { Onboarding } from "types/Onboarding";
import { AppDispatch } from "configureStore";

interface OnboardingsState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: Onboarding[];
  filtersValue: any;
}

const initialState: OnboardingsState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
  filtersValue: {},
};

const OnboardingsSlice = createSlice({
  name: "onboardings",
  initialState,
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<{ error: string }>) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state, action: PayloadAction<Onboarding[]>) {
      state.collection = Array.isArray(action.payload) ? action.payload : [];
      state.isLoading = false;
    },
    setFilterValue(state, action) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
});

const { actions, reducer } = OnboardingsSlice;

export const { setDestroy, setLoading, setError, setData, setFilterValue } =
  actions;
export default reducer;

export const fetchOnboardingsThunk =
  (companyId: string, filtersValue: any = {}) =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const data = await fetchOnboardings(companyId, filtersValue);
      dispatch(setData(data));
    } catch (e) {
      dispatch(setError({ error: "not_fetch" }));
    } finally {
      dispatch(setLoading(false));
    }
  };
